import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-medium);
	.list-with-scroll-empty {
		padding-top: var(--px-160);
	}
`;
